
const GET_EVENT_REG_LINKS = 'GET_EVENT_REG_LINKS';
const GET_ORG_EVENT_COMPETITIONS = 'GET_ORG_EVENT_COMPETITIONS';
const NEW_EVENT_REGISTRATION = 'NEW_EVENT_REGISTRATION';
const UPDATE_EVENT_REGISTRATION = 'UPDATE_EVENT_REGISTRATION';
const DELETE_EVENT_REGISTRATION = 'DELETE_EVENT_REGISTRATION';
const GET_EVENT_REG_BY_ID = 'GET_EVENT_REG_BY_ID';
const SEND_MAIL = 'SEND_MAIL';
const GET_USER_DATA = 'GET_USER_DATA';

const SET_LINK = 'SET_LINK';
const SET_EVENT_COMPETITION = 'SET_EVENT_COMPETITION';
const SET_EVENT = 'SET_EVENT';

const REMOVE_EVENT_COMPETITION = 'REMOVE_EVENT_COMPETITION';

export default {
	GET_EVENT_REG_LINKS,
	GET_ORG_EVENT_COMPETITIONS,
	NEW_EVENT_REGISTRATION,
	UPDATE_EVENT_REGISTRATION,
	DELETE_EVENT_REGISTRATION,
	GET_EVENT_REG_BY_ID,
	SEND_MAIL,
	GET_USER_DATA,
	SET_LINK,
	SET_EVENT_COMPETITION,
	SET_EVENT,
	REMOVE_EVENT_COMPETITION,
};
